import { FieldWithRequirement } from 'shared/data/webApp/v2';

export const isFieldRequirement = (value: unknown): value is FieldWithRequirement => {
    return Boolean(value && typeof value === 'object' && 'requirement' in value);
};
